import React, { useState } from 'react';
import tshirt from '../../../Assets/Photos/tshirt.png';
import print from '../../../Assets/Photos/ImageGallary.png';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { AddressDetailsPreview, DesignPreview, ImagePrintPreview, LabeledInput } from '../../../Components';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { PopupModal } from '../../../Modals/Index';
import './style.css';
import { SendMail } from '../..';
const Index = ({ state, setStateFalse, type }) => {
    const [mail, setMail] = useState(false);
    const [productName, setProductname] = useState('Butter Yellow M Men Round');
    const [quantity, setqty] = useState(1);
    return (
        <>
            <SendMail
                setStateFalse={() => {
                    setMail((prev) => !prev);
                }}
                state={mail}
                email="kushagrathreearrow@gmail.com"
            />
            <PopupModal setStateFalse={setStateFalse} state={state}>
                <div className="popupConatiner">
                    <div className="home_head flex-start">
                        <div className="home_head">
                            <div>
                                <h2 className="home_heading">Order Details</h2>
                                <p className="home_subtext">Reference Number: XXXXXX</p>
                            </div>
                            {type !== 'merchant' && (
                                <div>
                                    <p className="home_subtext">Merchant Name: XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
                                    <p className="home_subtext">Merchant ID: XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="popup_body">
                        <div className="product_details">
                            <div className="product_details_left">
                                <div
                                    style={{
                                        overflowY: 'auto',
                                        maxHeight: `calc(100vh - ${type !== 'merchant' ? '34rem' : '28rem'})`,
                                        paddingRight: '1rem',
                                    }}
                                >
                                    {/*----First Product---*/}
                                    <LabeledInput
                                        name="Product Name"
                                        value={productName}
                                        changeHandler={(e) => {
                                            setProductname(e.target.value);
                                        }}
                                        style={{ margin: '1rem 0' }}
                                        label={'Product Name'}
                                    />
                                    <div className="product_details_left_mid">
                                        <LabeledInput info name="Price" value={183.75} label={'Price'} />
                                        <LabeledInput
                                            name="Quantity"
                                            value={quantity}
                                            changeHandler={(e) => {
                                                setqty(e.target.value);
                                            }}
                                            label={'Quantity'}
                                        />
                                    </div>
                                    <p className="product_details_body_subheading">Design</p>
                                    <DesignPreview front={tshirt} back={tshirt} sleeve={tshirt} small />
                                    <p className="product_details_body_subheading">Added Images</p>
                                    <ImagePrintPreview front={print} back={print} sleeve={print} small />
                                    {/*----First Product End---*/}
                                    {/*----Another Product---*/}
                                    <LabeledInput
                                        name="Product Name"
                                        value={productName}
                                        changeHandler={(e) => {
                                            setProductname(e.target.value);
                                        }}
                                        style={{ margin: '1rem 0' }}
                                        label={'Product Name'}
                                    />
                                    <div className="product_details_left_mid">
                                        <LabeledInput info name="Price" value={183.75} label={'Price'} />
                                        <LabeledInput
                                            name="Quantity"
                                            value={quantity}
                                            changeHandler={(e) => {
                                                setqty(e.target.value);
                                            }}
                                            label={'Quantity'}
                                        />
                                    </div>
                                    <p className="product_details_body_subheading">Design</p>
                                    <DesignPreview front={tshirt} back={tshirt} sleeve={tshirt} small />
                                    <p className="product_details_body_subheading">Added Images</p>
                                    <ImagePrintPreview front={print} back={print} sleeve={print} small />
                                    {/*----Another End---*/}
                                </div>
                                {type !== 'merchant' && (
                                    <button className="btn-gray" style={{ marginTop: '2rem', width: 'max-content' }}>
                                        Download All Images
                                    </button>
                                )}
                            </div>
                            <div className="product_details_right">
                                <div className="product_details_right_top">
                                    <AddressDetailsPreview heading="Billing Address" />
                                    <AddressDetailsPreview heading="Shipping Address" />
                                    {type !== 'merchant' && (
                                        <div className="product_details_status_div">
                                            <p
                                                style={{ marginTop: '0', color: '#000000' }}
                                                className="product_details_body_subheading"
                                            >
                                                Change to
                                            </p>
                                            <div className="product_details_status_item">
                                                <p className={`circle processing`}></p>
                                                <span>processing</span>
                                            </div>
                                            <div className="product_details_status_item">
                                                <p className={`circle readytoDispatched`}></p>
                                                <span>ready to Dispatched</span>
                                            </div>
                                            <div className="product_details_status_item">
                                                <p className={`circle Dispatched`}></p>
                                                <span>Dispatched</span>
                                            </div>
                                            <div className="product_details_status_item">
                                                <p className={`circle Onhold`}></p>
                                                <span>On hold</span>
                                            </div>
                                            <div className="product_details_status_item">
                                                <p className={`circle Cancelled`}></p>
                                                <span>Cancelled</span>
                                            </div>
                                            <div className="product_details_status_item">
                                                <p className={`circle Return`}></p>
                                                <span>Return</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="product_details_right_foot">
                                    {type !== 'merchant' && (
                                        <button
                                            onClick={() => {
                                                setMail((prev) => !prev);
                                            }}
                                            style={{ marginRight: 'auto' }}
                                            className="btn-orange"
                                        >
                                            <MailOutlineIcon className="btn-icon" />
                                            <p>Contact Merchant</p>
                                        </button>
                                    )}
                                    <button
                                        onClick={setStateFalse}
                                        className="btn-gray"
                                        style={{ marginRight: '1rem' }}
                                    >
                                        <KeyboardBackspaceIcon className="btn-icon" />
                                        <p>Back</p>
                                    </button>
                                    {type !== 'merchant' && (
                                        <button className="btn-orange">
                                            <p>Save Changes</p>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PopupModal>
        </>
    );
};

export default Index;
